import React from 'react'

export function end_point(){
  console.log("REACT_APP_PRB_ENV=",process.env.REACT_APP_PRB_ENV)
  let endPoint = `REACT_APP_${process.env.REACT_APP_PRB_ENV}`
  console.log('end point', process.env[endPoint])
  return process.env[endPoint]
}